"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.envName = exports.reducer = undefined;

var _EnvConfig = require("../../redux/EnvConfig");

var EnvConfig = _interopRequireWildcard(_EnvConfig);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var reducer = exports.reducer = EnvConfig.reduceEntities;
var envName = exports.envName = function envName() {
  return EnvConfig.config.envName;
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZW50aXRpZXMyL2Vudi1jb25maWcuanMiXSwibmFtZXMiOlsiRW52Q29uZmlnIiwicmVkdWNlciIsInJlZHVjZUVudGl0aWVzIiwiZW52TmFtZSIsImNvbmZpZyJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUNBOztJQUFZQSxTOzs7O0FBR0wsSUFBTUMsNEJBQVVELFVBQVVFLGNBQTFCO0FBQ0EsSUFBTUMsNEJBQVUsU0FBVkEsT0FBVTtBQUFBLFNBQU1ILFVBQVVJLE1BQVYsQ0FBaUJELE9BQXZCO0FBQUEsQ0FBaEIiLCJmaWxlIjoiZW52LWNvbmZpZy5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIEBmbG93XG5pbXBvcnQgKiBhcyBFbnZDb25maWcgZnJvbSBcIi4uLy4uL3JlZHV4L0VudkNvbmZpZ1wiXG5cbmV4cG9ydCB0eXBlIFN0YXRlID0gRW52Q29uZmlnLkNvbmZpZ1xuZXhwb3J0IGNvbnN0IHJlZHVjZXIgPSBFbnZDb25maWcucmVkdWNlRW50aXRpZXNcbmV4cG9ydCBjb25zdCBlbnZOYW1lID0gKCkgPT4gRW52Q29uZmlnLmNvbmZpZy5lbnZOYW1lXG4iXX0=


//////////////////
// WEBPACK FOOTER
// ../core/lib/selectors/entities2/env-config.js
// module id = 814
// module chunks = 0